// extracted by mini-css-extract-plugin
module.exports = {"list":"list--4b2cd"};